import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import {
    Select,
    Spin
} from 'antd'

import { withTranslation } from 'react-i18next'

const SelectChartOfAccount = ({
    i18n,
    defaultValue,
    loading,
    onChange,
    onSearch,
    chartOfAccounts,
    value,
    ...restSelectProps
}) => {
    return (
        <Select
            allowClear
            defaultActiveFirstOption={false}
            defaultValue={defaultValue}
            filterOption={false}
            loading={loading}
            notFoundContent={loading ? <Spin size="small" /> : null}
            onChange={onChange}
            onSearch={onSearch}
            placeholder={i18n.t('chartOfAccounts:searchAccountNumber')}
            showArrow={false}
            showSearch
            style={restSelectProps.style || { width: '200px' }}
            value={value}
            {...restSelectProps}
        >
            {chartOfAccounts.map((chartOfAccount, index) => {
                return (
                    <Select.Option
                        key={_.get(chartOfAccount, 'id', `index-${index}`)}
                        value={_.get(chartOfAccount, 'id', undefined)}
                    >
                        {_.get(chartOfAccount, 'account_number', '')}
                    </Select.Option>
                )
            })}
        </Select>
    )
}

SelectChartOfAccount.propTypes = {
    defaultValue: PropTypes.string,
    loading: PropTypes.bool,
    onChange: PropTypes.func,
    onSearch: PropTypes.func,
    chartOfAccounts: PropTypes.array,
    value: PropTypes.string
}

SelectChartOfAccount.defaultProps = {
    defaultValue: undefined,
    loading: false,
    onChange: () => {},
    onSearch: () => {},
    chartOfAccounts: [],
    value: undefined
}

export default withTranslation(['chartOfAccounts'])(SelectChartOfAccount)

